import React from 'react'
import { Column, ColumnOptions, LetsTalk, PriceBox } from '../../../../components/PriceTable'
import { IconSelect } from '../../../../svg'
import { BILLING_CYCLE, MOST_POPULAR } from '../../constants'
import { PRODUCT_LIST, PRODUCT_NAMES_LIST } from '../../../../common/constants/ProductConstants'
import { useTranslation } from 'react-i18next'
import { BuyOrUpgradeButton } from './BuyOrUpgradeButton'

export const SubscriptionColumn = ({
    description,
    productAction,
    userSubscriptions,
    userSubscription,
    reduceAnnualYouSaveMsg,
    reduceTotalMsg,
    isMobile,
}) => {
    const { t } = useTranslation()
    const currentProduct = userSubscription.product
    const isMostPopular =
        description.name === MOST_POPULAR.name && description.billingCycleValue === MOST_POPULAR.billingCycleValue

    const priceDescription =
        description.billingCycleValue === BILLING_CYCLE.year && description.name !== 'Free'
            ? reduceAnnualYouSaveMsg(description.name)
            : ''
    const total =
        description.billingCycleValue === BILLING_CYCLE.year && description.name !== 'Free'
            ? reduceTotalMsg(description.name)
            : ''

    const activeSubscriptions = userSubscriptions.filter(subscription => subscription.expirationDate > Date.now())
    const isYearly = activeSubscriptions.some(
        subscription => subscription.product.billingCycleValue === BILLING_CYCLE.year,
    )

    const needRemoveDowngrade =
        activeSubscriptions.length >= 2 &&
        isYearly &&
        Object.values(PRODUCT_LIST).indexOf(description.productCode) <
            Object.values(PRODUCT_LIST).indexOf(userSubscription.product.productCode)

    const priceMap = price =>
        description.billingCycleValue === BILLING_CYCLE.year ? Math.round(price / BILLING_CYCLE.year) : price

    const isProductSelected =
        (description.productCode === currentProduct.productCode &&
            description.billingCycleValue === currentProduct.billingCycleValue) ||
        (description.productCode === currentProduct.productCode &&
            currentProduct.billingCycleValue === BILLING_CYCLE.infinite)

    return (
        <Column
            className={`subscriptions__column-table ${isProductSelected ? 'subscriptions__column-table_selected' : ''}`}
            description={description}
        >
            {(description, options, isMobile) => {
                return (
                    <>
                        <div className="subscriptions__column-header">
                            {isProductSelected ? <IconSelect /> : null}
                            {isMostPopular ? <span>{t('_pages._billing_and_payments.most_popular')}</span> : null}
                        </div>
                        {description.name !== PRODUCT_NAMES_LIST.Enterprise ? (
                            <>
                                <PriceBox title={description.name} price={priceMap(description.price)} />
                                <span className="subscriptions__price-total">
                                    {total} <span className="subscriptions__price-description">{priceDescription}</span>
                                </span>
                                <BuyOrUpgradeButton
                                    productAction={productAction}
                                    needRemoveDowngrade={needRemoveDowngrade}
                                    recurringEnabled={userSubscription.recurringEnabled}
                                />
                            </>
                        ) : (
                            <LetsTalk title={description.name} style={{ marginBottom: '107px' }} />
                        )}
                        <ColumnOptions options={options} shortened={isMobile} />
                    </>
                )
            }}
        </Column>
    )
}
